import React from "react";

export const isEmptyNode = (node: React.ReactNode): boolean => {
  if (Array.isArray(node)) {
    return node.every(isEmptyNode);
  }
  if (node === null || node === undefined || node === false) {
    return true;
  }
  if (typeof node === "string" || typeof node === "number") {
    return node === "";
  }
  if (React.isValidElement(node) && node.props.children) {
    return isEmptyNode(node.props.children);
  }
  return false;
};
